import produce from "immer"

const currentState = produce((state, action) => {
  switch(action.type) {
  }
  return state
})

export default currentState
